import {
  FormInputElement,
  SignupForm,
  styleSheet,
} from "@redotech/redo-model/signup-form";
import { memo } from "react";
import { ExternalLink } from "../../link";
import { Text } from "../../text";
import * as singupFormCss from "../signup-form.module.css";
import { FormElementProps } from "./index";

export const Input = memo(function Input({
  form,
  element,
}: FormElementProps<FormInputElement>) {
  const style = GetInputStyle(form);
  return (
    <>
      <div className={singupFormCss.inputBox} style={style}>
        <input
          name={element.inputType} // assuming one input per type per form step
          pattern={element.inputType === "email" ? ".+@.+\\..+" : ".{10,}"}
          placeholder={element.placeholderText}
          required
          style={{ width: "100%" }}
          type={element.inputType === "email" ? "email" : "tel"}
        />
      </div>
      {element.inputType === "phone" && (
        <Text
          className={singupFormCss.legalDisclaimer}
          dir="column"
          mt="lg"
          textColor="tertiary"
        >
          By providing your phone number, you agree to receive recurring
          automated marketing text messages (e.g. cart reminders) from this shop
          and third parties acting on its behalf. Consent is not a condition to
          obtain goods or services. Msg & data rates may apply. Msg frequency
          varies. Reply HELP for help and STOP to cancel. You also agree to the{" "}
          <ExternalLink
            showIcon={false}
            url="https://www.getredo.com/terms-conditions"
          >
            Terms of Service
          </ExternalLink>{" "}
          and{" "}
          <ExternalLink
            showIcon={false}
            url="https://www.getredo.com/privacy-policy"
          >
            Privacy Policy.
          </ExternalLink>
        </Text>
      )}
    </>
  );
});

function GetInputStyle(form: SignupForm): React.CSSProperties {
  const override = form.theme.overrides.inputs.enabled;
  const strokeEnabled = form.theme.overrides.inputs.box.border.stroke.enabled;
  return {
    backgroundColor: override
      ? form.theme.overrides.inputs.box.backgroundColor
      : styleSheet.inputs.backgroundColor,
    outlineWidth: override
      ? `${form.theme.overrides.inputs.box.border.stroke.weightPx}px`
      : `${styleSheet.inputs.border.stroke.weightPx}px`,
    outlineStyle: "solid",
    color: override
      ? form.theme.overrides.inputs.box.textColor
      : styleSheet.inputs.textColor,
    outlineColor: override
      ? strokeEnabled
        ? form.theme.overrides.inputs.box.border.stroke.color
        : "transparent"
      : styleSheet.inputs.border.stroke.enabled
        ? styleSheet.inputs.border.stroke.color
        : "transparent",
    borderRadius: `${
      override
        ? form.theme.overrides.inputs.box.border.cornerRadiusPx
        : styleSheet.inputs.border.cornerRadiusPx
    }px`,
  };
}
